/**
 * myseed-certificate
 */

// Module dependencies
import 'protons';

// Module template
import './_myseed-certificate.twig';

// All Vue widgets only execute on existence of DOM
import VueMyseedCertificate from 'lib/vue-widget/src/vue-myseed-certificate';

// Render Vue elements as soon as possible
if (document.getElementById('myseed-certificate')) {
  VueMyseedCertificate('#myseed-certificate');
}

export const name = 'myseed-certificate';
export function disable() {}
export function enable() {}
export default enable;
